import { gql } from '@apollo/client';

const USER_NOTIFICATION = gql`query userNotifications($offset:Int!){
	userNotificationContext{
		notifications (offset: $offset){
			unreadCount
			totalCount
			notifications{
				actor{
					avatarUrl
					name
					username					
				}
				aggregationCount
				createdAt
				eventChannel
				eventId

				folderPayload
				{
					folderId
					folderName
				}
				resourcePayload
				{
					 folderId
					resourceId
					resourceName
				}
				
				readAt
				createdAt
				siteId
				siteName
				updatedAt
				userId
				userNotificationId
				__typename
			}
		}
	}
}`;

export default USER_NOTIFICATION;